import { i18n } from '@/locales';
const lc = 'views.store_management.';
// 상점상태 타입(storeStatusType)
// https://qc-zoo-client-api.barogo.io/docs/common/store-status-type.html
export const storeStatusTypeCode = [
    // 전체
    'ALL',
    // 정상
    'ON',
    // 정지
    'PAUSE',
    // 종료
    'OFF',
    // 삭제
    'DELETE',
];
const imgIconCodeList = {
    ALL: '',
    ON: 'ok',
    PAUSE: 'stop',
    OFF: 'leave',
};
export default storeStatusTypeCode.map((code) => ({
    text: i18n.t(`${lc}${code.toLowerCase()}`),
    value: code,
    field: 'useYn',
    imgIcon: imgIconCodeList[code],
}));
/**
 * 상점 수행상황 (임의값)
 */
export const storeDeliveryStatusType = {
    Y: {
        value: 'Y',
        text: 'common.bulletin_good',
    },
    D: {
        value: 'D',
        text: 'common.delay',
    },
};
